import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQAccordion = ({ faqs }) => {
  if (!faqs || faqs.length === 0) return null;

  return (
    <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
      {faqs.map((faq, index) => (
        <AccordionItem
          key={faq.id || index}
          value={`item-${faq.id || index}`}
          className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden px-6"
        >
          <AccordionTrigger
            className="py-5 text-left font-nunito font-bold text-gray-800 hover:text-burgundy hover:no-underline"
            data-testid={`faq-trigger-${index}`}
          >
            {faq.question}
          </AccordionTrigger>
          <AccordionContent
            className="pb-5 text-gray-600 leading-relaxed font-nunito"
            data-testid={`faq-content-${index}`}
          >
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
